module.exports = __webpack_public_path__ + "img/icons BFr_29.b4ecad81.png";